import { timestampPdfFilename } from "../utils/download";
import apiClient from "./apiClient";
import { Quote } from "../types/quote";
import { readPage } from "../utils/paginatedResult";

function createIdempotencyKey(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export async function getQuotes(page = 1, search = "", startDate = "", endDate = "", signal?: AbortSignal) {
  const params = Object.fromEntries(Object.entries({ page, limit: 10, search, startDate, endDate }).filter(([, value]) => value !== ""));
  return readPage<Quote>((await apiClient.get("quotes", { params, signal })).data);
}
export async function getQuote(id: string, signal?: AbortSignal): Promise<Quote> {
  return (await apiClient.get<{ data: { quote: Quote } }>(`quotes/${encodeURIComponent(id)}`, { signal })).data.data.quote;
}
export async function deleteQuote(id: string) { await apiClient.delete(`quotes/${encodeURIComponent(id)}`); }

export async function emailQuote(id: string, message = "") {
  return (await apiClient.post<{ message: string; quoteId: string; recipient: string; queuedAt: string; deliveryId: string }>(
    `quotes/${encodeURIComponent(id)}/email`,
    message ? { message } : {},
    { headers: { "Idempotency-Key": createIdempotencyKey() } },
  )).data;
}

export async function downloadQuotePdf(id: string): Promise<{ blob: Blob; filename: string }> {
  const response = await apiClient.get<Blob>(`quotes/${encodeURIComponent(id)}/pdf`, { responseType: "blob" });
  return {
    blob: response.data,
    filename: timestampPdfFilename(),
  };
}
